module.exports = __webpack_public_path__ + "img/eth.4edf3ba6.svg";